import * as angular from 'angular';

import { Alarm, AlarmList } from '../../models';
import { IDispatcherService, IDispatcher, IAlarmActionsService } from '../';

export interface IAlarmStoreService {
    getOne(guid: string): angular.IPromise<Alarm>;
    getByIdentifierGuid(guid: string): angular.IPromise<Alarm[]>;
    getAll(): angular.IPromise<AlarmList>;
    getAll(force: boolean): angular.IPromise<AlarmList>;
    getAllForIdentifier(identifierGuid: string): angular.IPromise<Alarm[]>;
    getAllForIdentifiers(identifierGuids: string[]): angular.IPromise<AlarmList>;
    addOne(identifierGuid: string, targetAlarm: Alarm): angular.IPromise<AlarmList>;
    addMany(identifierGuid: string, targetAlarms: Alarm[]): angular.IPromise<AlarmList>;
    updateOne(identifierGuid: string, targetAlarm: Alarm): angular.IPromise<AlarmList>;
    updateMany(identifierGuid: string, targetAlarms: Alarm[]): angular.IPromise<AlarmList>;
    updateMultiple(value: AlarmList): angular.IPromise<AlarmList>;
    deleteOne(identifierGuid: string, alarmGuid: string): angular.IPromise<AlarmList>;
    forceInMemoryUpdate(updated: AlarmList): angular.IPromise<AlarmList>;
}

export interface IAlarmActionsDispatcherService extends IDispatcherService<IAlarmStoreService> { }

export class AlarmActionsDispatcherService implements IAlarmActionsDispatcherService {
    static serviceId = 'alarmActionsDispatcherService';

    static $inject = ['alarmActionsService'];

    constructor(private _actionService: IAlarmActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IAlarmStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getByIdentifierGuid: (guid: string) => dispatch(actionService.getByIdentifierGuid(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                getAllForIdentifier: (guid: string) => dispatch(actionService.getAllForIdentifier(guid)),
                getAllForIdentifiers: (guids: string[]) => dispatch(actionService.getAllForIdentifiers(guids)),
                addOne: (g: string, a: Alarm) => dispatch(actionService.addOne(g, a)),
                addMany: (g: string, a: Alarm[]) => dispatch(actionService.addMany(g, a)),
                updateOne: (g: string, a: Alarm) => dispatch(actionService.updateOne(g, a)),
                updateMany: (g: string, a: Alarm[]) => dispatch(actionService.updateMany(g, a)),
                updateMultiple: (value: AlarmList) => dispatch(actionService.updateMultiple(value)),
                deleteOne: (g: string, a: string) => dispatch(actionService.deleteOne(g, a)),
                forceInMemoryUpdate: (updated: AlarmList) => dispatch(actionService.forceInMemoryUpdate(updated))
            }
        };
    }
}